export var BotDifficulty = /*#__PURE__*/ function(BotDifficulty) {
    BotDifficulty[BotDifficulty["BotEasy"] = 0] = "BotEasy";
    BotDifficulty[BotDifficulty["BotMedium"] = 1] = "BotMedium";
    BotDifficulty[BotDifficulty["BotHard"] = 2] = "BotHard";
    return BotDifficulty;
}({});
